import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M24.81-.048c-8.268 0-16 4.15-20.6 10.71v-7.8H0v14.64h14.94V13.29h-7.4c3.817-5.516 10.417-9.127 17.27-9.127 11.465 0 20.79 9.326 20.79 20.79s-9.325 20.79-20.79 20.79c-8.43 0-15.97-5.032-19.205-12.817L1.717 34.54c3.89 9.364 12.954 15.413 23.094 15.413 13.788 0 25.005-11.215 25.005-25s-11.217-25-25.002-25zM22.976 11.01l-.225 16.87 11.597 5.32 1.256-2.733-9.817-4.504.2-14.915-3.008-.04z"
  })]
});